import { Pipe, PipeTransform } from "@angular/core";
import { concatNotNull } from "../../utils/string-utils";

@Pipe({
  name: "concatNotNull",
  standalone: true,
})
export class ConcatNotNullPipe implements PipeTransform {
  transform(
    values: (string | { toString: () => string } | undefined | null)[],
    separator: string = " "
  ): string {
    return concatNotNull(values, separator);
  }
}
